export type ContractCenterCapabilities = {
  canSubmit?: boolean;
  canWithdraw?: boolean;
  canDelete?: boolean;
  canRestore?: boolean;
  canBatchStatus?: boolean;
};

export type ContractCenterRecord = {
  centerBacked?: boolean;
  contractTypeUuid?: string;
  centerStatus?: string;
  capabilities?: ContractCenterCapabilities;
  auditStatus?: number;
  workflowInstanceUuid?: string;
  processInstanceUuid?: string;
};

export const CENTER_STATUS_LABELS: Record<string, string> = {
  DRAFT: '草稿',
  PENDING: '审批中',
  REJECTED: '已驳回',
  PENDING_SIGN: '待签署',
  SIGNED: '已签署',
  ACTIVE: '履约中',
  COMPLETED: '已完成',
  TERMINATED: '已终止',
  VOIDED: '已作废',
};

export function isCenterBackedContract(record?: ContractCenterRecord | null) {
  return Boolean(
    record?.centerBacked || record?.contractTypeUuid || record?.centerStatus,
  );
}

export function canEditContract(record?: ContractCenterRecord | null) {
  if (isCenterBackedContract(record)) {
    const status = String(record?.centerStatus || '');
    return status === 'DRAFT' || status === 'REJECTED';
  }
  return [0, 3].includes(Number(record?.auditStatus ?? 0));
}

export function canDeleteContract(record?: ContractCenterRecord | null) {
  return !isCenterBackedContract(record);
}

export function canRestoreContract(record?: ContractCenterRecord | null) {
  return !isCenterBackedContract(record);
}

export function resolveCenterStatusLabel(status?: string) {
  const key = String(status || '').trim();
  return CENTER_STATUS_LABELS[key] || key || '-';
}

const LEGACY_AUDIT_STATUS_LABELS: Record<number, string> = {
  0: '草稿',
  1: '审批中',
  2: '已通过',
  3: '已驳回',
};

export function resolveContractDisplayStatusLabel(
  record?: ContractCenterRecord | null,
) {
  if (isCenterBackedContract(record)) {
    return resolveCenterStatusLabel(record?.centerStatus);
  }
  const status = Number(record?.auditStatus ?? 0);
  return (
    LEGACY_AUDIT_STATUS_LABELS[status] || String(record?.auditStatus ?? '-')
  );
}
